import { crmApiInstance } from './client.js';

export const customizationsApi = {
  getByProduct:     (productId)               => crmApiInstance.get(`/products/${productId}/customizations`).then(r => r.data),
  getAll:           (params = {})             => crmApiInstance.get('/customizations', { params }).then(r => r.data),
  getById:          (id)                      => crmApiInstance.get(`/customizations/${id}`).then(r => r.data),
  create:           (formData)                => crmApiInstance.post('/customizations', formData).then(r => r.data),
  update:           (id, formData)            => crmApiInstance.put(`/customizations/${id}`, formData).then(r => r.data),
  delete:           (id)                      => crmApiInstance.delete(`/customizations/${id}`).then(r => r.data),
  assign:           (productId, payload)      => crmApiInstance.post(`/products/${productId}/customizations`, payload).then(r => r.data),
  removeAssignment: (productId, assignmentId) => crmApiInstance.delete(`/products/${productId}/customizations/${assignmentId}`).then(r => r.data),
};
